import WarrantyServiceFacade from "@robotical/appv2-warranty-service-lib/dist/facade/WarrantyServiceFacade";
import Logger from "../services/logger/Logger";
import { LoginToken } from "@robotical/appv2-warranty-service-lib/dist/types/serviceProgramDatabase";

const SHOW_LOGS = true;
const TAG = "LoginUtils";

export const doesUserExist = async (email: string) => {
    Logger.info(SHOW_LOGS, TAG, "Checking if user exists with email: " + email);
    const user = await WarrantyServiceFacade.getUser(email);
    return !!user;
};

export const storeLoginToken = async (email: string): Promise<LoginToken | false> => {
    Logger.info(SHOW_LOGS, TAG, "Storing login token for user with email: " + email);
    const token = await WarrantyServiceFacade.addLoginTokenToUser(email);
    return token;
};